import { withStyles } from '@material-ui/core';
import React from 'react';

const MessageText_ = ({ idCountry, classes }) => {
  if (idCountry === 'COL') {
    return (
      <p className={classes.message}>
        Comparte este link de tu tienda en tus redes sociales para empezar a
        vender.
      </p>
    );
  }

  return (
    <p className={classes.message}>
      Compartí este link de tu tienda en tus redes sociales para empezar a
      vender.
    </p>
  );
};

const styles = () => ({
  message: {
    margin: '0',
    color: '#565656',
  },
});

export const MessageText = withStyles(styles)(MessageText_);
